import {
  PRODUCT_SETTINGS_CHILDREN_ENDPOINT,
  PRODUCT_SETTINGS_PARENTS_ENDPOINT
} from 'constants/api'

export const updatedProductCache = ({ productIds, data, newData }) => ({
  ...data,
  data: {
    ...data.data,
    products: data.data.products.map(oldProduct => {
      let updated = oldProduct
      if (productIds.includes(oldProduct.id)) {
        updated = { ...oldProduct, ...newData }
      }

      updated.children = oldProduct.children?.map(oldChild => {
        if (productIds.includes(oldChild.id)) {
          return {
            ...oldChild,
            ...newData
          }
        }
        return oldChild
      })

      return updated
    })
  }
})

const updateChildren = ({ productIds, data, newData }) => ({
  ...data,
  data: {
    children: data?.data?.children?.map(oldChild =>
      productIds.includes(oldChild.id) ? { ...oldChild, ...newData } : oldChild
    )
  }
})

export const updateChildrenCache = async (productIds, queryClient, newData) => {
  const endpoint = PRODUCT_SETTINGS_CHILDREN_ENDPOINT
  await queryClient.cancelQueries(endpoint)

  const { queries } = queryClient.getQueryCache()

  const relatedQueries = queries.filter(q => q.queryKey[0] === endpoint)

  relatedQueries.forEach(({ queryKey, state: { data } }) => {
    queryClient.setQueryData(
      [queryKey[0], queryKey[1].data],
      updateChildren({ productIds, data, newData })
    )
  })
}

export const updateProductCostsAndSettingsCache = async (
  productIds,
  queryClient,
  updatedProduct
) => {
  const productId = updatedProduct.product_id || updatedProduct.id
  const newData = {
    ...updatedProduct,
    ...(productId ? { id: productId, product_id: productId } : {})
  }

  await queryClient.cancelQueries(PRODUCT_SETTINGS_PARENTS_ENDPOINT)

  const { queries } = queryClient.getQueryCache()

  const relatedQueries = queries.filter(
    q => q.queryKey[0] === PRODUCT_SETTINGS_PARENTS_ENDPOINT
  )
  relatedQueries.forEach(({ queryKey, state: { data } }) => {
    queryClient.setQueryData(
      [queryKey[0], queryKey[1].data],
      updatedProductCache({ productIds, data, newData })
    )
  })

  await updateChildrenCache(productIds, queryClient, newData)
}

export const invalidateCostsCache = (queryClient, product) => {
  queryClient.invalidateQueries([
    'api/junglekit/product_costs',
    {
      data: {
        amazon_seller_account_id: product.amazon_seller_account_id,
        marketplace_id: product.marketplace_id,
        product_id: product.product_id
      }
    }
  ])
}
